/* src/app/private/components/contact-group/contact-group-list/contact-group-list.component.scss */
/*# sourceMappingURL=contact-group-list.component.css.map */
